import { useTranslation } from "react-i18next";

export const TRANSPORT_SAME_VERSION = "transportSameVersion";
export const TRANSPORT_SAME_VERSION_REFERENCES = "transportSameVersionReferences";
const permissionCodes = [TRANSPORT_SAME_VERSION, TRANSPORT_SAME_VERSION_REFERENCES];
export const accountAdminPermissions = account => account?.role === "admin" && Array.isArray(account.adminPermissions)
  ? account.adminPermissions.filter(permission => typeof permission === "string") : [];

// The backend enforces the same restriction before every account mutation.
export const hasProtectedAdminPermissions = account => accountAdminPermissions(account).length > 0;

export default function AdminPermissionsField({ id, role, value = [], editable = false, disabled = false, onChange }) {
  const { t } = useTranslation("benutzer");
  if (role !== "admin") return null;
  const accessId = `${id}-access`;
  return <fieldset style={{ border: 0, padding: 0, margin: "14px 0", minWidth: 0, fontFamily: "'Source Sans 3', sans-serif", color: "var(--iio-text-1)" }}>
    <legend style={{ fontSize: 13, fontWeight: 600, padding: 0, marginBottom: 4 }}>{t("adminPermissions.label")}</legend>
    {permissionCodes.map((permission, index) => {
      const fieldId = index === 0 ? id : `${id}-${permission}`;
      const descriptionId = `${fieldId}-description`;
      return <div key={permission} style={{ marginTop: index ? 12 : 0 }}>
        <label htmlFor={fieldId} style={{ display: "flex", alignItems: "center", gap: 10, minHeight: 44, fontSize: 14, fontWeight: 600, letterSpacing: "normal", textTransform: "none", color: "var(--iio-text-1)", cursor: editable && !disabled ? "pointer" : "default" }}>
          <input id={fieldId} type="checkbox" checked={value.includes(permission)} disabled={!editable || disabled}
            aria-describedby={`${descriptionId}${!editable ? ` ${accessId}` : ""}`}
            style={{ flexShrink: 0, width: 18, height: 18, margin: 0, accentColor: "var(--iio-info)" }}
            onChange={event => {
              if (!editable || disabled) return;
              const next = event.target.checked ? [...value, permission] : value.filter(code => code !== permission);
              onChange(permissionCodes.filter(code => next.includes(code)));
            }} />
          <span>{t(`adminPermissions.${permission}`)}</span>
        </label>
        <div id={descriptionId} style={{ fontSize: 13, lineHeight: 1.5, color: "var(--iio-text-2)" }}>{t(`adminPermissions.${permission}Description`)}</div>
      </div>;
    })}
    {!editable && <div id={accessId} style={{ marginTop: 4, fontSize: 13, lineHeight: 1.5, color: "var(--iio-text-2)" }}>{t("adminPermissions.superadminOnly")}</div>}
  </fieldset>;
}
